import React, { useCallback, useContext, useState } from "react";
import { NotificationsContext } from "../../Notifications";
import { useIntl, FormattedMessage } from "react-intl";
import Input from "../../Input";
import Modal from "../../Modal";
import Toggle from "../../Toggle";
import Button from "../../Button";

function AddProductDialog({ onConfirm, onClose, loading, roles }) {

  // context
  const { push } = useContext(NotificationsContext);

  // hooks
  const intl = useIntl();

  // state
  const [art_cod, setArtCod] = useState("");
  const [art_type_cod, setArtTypeCod] = useState("");
  const [art_des_it, setArtDesIt] = useState("");
  const [art_des_cmpy, setArtDesCmpy] = useState("");
  const [prod_line_cod, setProdLineCod] = useState("");
  const [ref_cmpy_cod, setRefCmpyCod] = useState("");
  const [base_um, setBaseUm] = useState("");
  const [min_qty, setMinQty] = useState(null);
  const [bdg_cls_cod, setBdgClsCod] = useState("");
  const [prod_stat_cod, setProdStatCod] = useState("");
  const [prod_stat_des, setProdStatDes] = useState("");
  const [pso_art_status_cod, setPsoArtStatusCod] = useState("");
  const [prezzo, setPrezzo] = useState(null);
  const [resa, setResa] = useState(null);
  const [unita_mis_resa, setUnitaMisResa] = useState("");
  const [spessore_min, setSpessoreMin] = useState(null);
  const [link_scheda_tecnica, setLinkSchedaTecnica] = useState("");
  const [link_video, setLinkVideo] = useState("");
  const [flg_kpi, setFlgKpi] = useState(false);
  const [link_image, setLinkImage] = useState("");
  const [active, setActive] = useState(true);

  // utilities
  const _onSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      if (!art_cod || !art_des_cmpy) {
        push({
          title: intl.formatMessage({ id: "enter_required_fields" }),
          type: "error",
        });
        return;
      }

      await onConfirm({
        art_cod,
        art_type_cod,
        art_des_it,
        art_des_cmpy,
        prod_line_cod,
        ref_cmpy_cod,
        base_um,
        min_qty,
        bdg_cls_cod,
        prod_stat_cod,
        prod_stat_des,
        pso_art_status_cod,
        prezzo,
        resa,
        unita_mis_resa,
        spessore_min,
        link_scheda_tecnica,
        link_video,
        r_perm: [],
        w_perm: [],
        created_at: "",
        flg_kpi,
        link_image,
        business_id: 1,
        active,
        manual: true,
      });
    },
    // eslint-disable-next-line
    [
      art_cod,
      art_type_cod,
      art_des_it,
      art_des_cmpy,
      prod_line_cod,
      ref_cmpy_cod,
      base_um,
      min_qty,
      bdg_cls_cod,
      prod_stat_cod,
      prod_stat_des,
      pso_art_status_cod,
      prezzo,
      resa,
      unita_mis_resa,
      spessore_min,
      link_scheda_tecnica,
      link_video,
      flg_kpi,
      link_image,
      active,
      push,
    ]
  );

  return (
    <Modal onExit={onClose}>
      <div className="m-8">
        <h3 className="text-center text-2xl font-extrabold text-black-500">
          <FormattedMessage id="add_product" />
        </h3>
      </div>

      <form id="add-product-form" onSubmit={_onSubmit}>
        <div>
          <Input
            value={art_cod}
            onChange={(e) => {
              setArtCod(e.target.value);
            }}
            label="Art Cod"
            type="text"
            errorMessage={intl.formatMessage({
              id: "enter_art_cod",
            })}
            required
          />
          <Input
            value={art_type_cod}
            onChange={(e) => {
              setArtTypeCod(e.target.value);
            }}
            label="Art Type Cod"
            type="text"
          />
          <Input
            value={art_des_it}
            onChange={(e) => {
              setArtDesIt(e.target.value);
            }}
            label="Art Des It"
            type="text"
          />
          <Input
            value={art_des_cmpy}
            onChange={(e) => {
              setArtDesCmpy(e.target.value);
            }}
            label="Art Des Cmpy"
            type="text"
            errorMessage={intl.formatMessage({
              id: "enter_des_cmpy",
            })}
            required
          />
          <Input
            value={prod_line_cod}
            onChange={(e) => {
              setProdLineCod(e.target.value);
            }}
            label="Prod Line Cod"
            type="text"
          />
          <Input
            value={ref_cmpy_cod}
            onChange={(e) => {
              setRefCmpyCod(e.target.value);
            }}
            label="Ref Cmpy Cod"
            type="text"
          />
          <Input
            value={base_um}
            onChange={(e) => {
              setBaseUm(e.target.value);
            }}
            label="Base UM"
            type="text"
          />
          <Input
            value={min_qty}
            onChange={(e) => {
              setMinQty(e.target.value);
            }}
            label="Min Qty"
            type="number"
          />
          <Input
            value={bdg_cls_cod}
            onChange={(e) => {
              setBdgClsCod(e.target.value);
            }}
            label="Bdg Cls Cod"
            type="text"
          />
          <Input
            value={prod_stat_cod}
            onChange={(e) => {
              setProdStatCod(e.target.value);
            }}
            label="Prod Stat Cod"
            type="text"
          />
          <Input
            value={prod_stat_des}
            onChange={(e) => {
              setProdStatDes(e.target.value);
            }}
            label="Prod Stat Des"
            type="text"
          />
          <Input
            value={pso_art_status_cod}
            onChange={(e) => {
              setPsoArtStatusCod(e.target.value);
            }}
            label="Pso Art Status Cod"
            type="text"
          />
          <Input
            value={prezzo}
            onChange={(e) => {
              setPrezzo(e.target.value);
            }}
            label="Prezzo"
            type="number"
          />
          <Input
            value={resa}
            onChange={(e) => {
              setResa(e.target.value);
            }}
            label="Resa"
            type="number"
          />
          <Input
            value={unita_mis_resa}
            onChange={(e) => {
              setUnitaMisResa(e.target.value);
            }}
            label="Unita Mis Resa"
            type="text"
          />
          <Input
            value={spessore_min}
            onChange={(e) => {
              setSpessoreMin(e.target.value);
            }}
            label="Spessore Min"
            type="number"
          />
          <Input
            value={link_scheda_tecnica}
            onChange={(e) => {
              setLinkSchedaTecnica(e.target.value);
            }}
            label="Link Scheda Tecnica"
            type="text"
          />
          <Input
            value={link_video}
            onChange={(e) => {
              setLinkVideo(e.target.value);
            }}
            label="Link Video"
            type="text"
          />
          <Input
            value={link_image}
            onChange={(e) => {
              setLinkImage(e.target.value);
            }}
            label="Link Image"
            type="text"
          />
          <Toggle
            vertical
            label="Flg Kpi"
            checked={flg_kpi}
            onChange={() => setFlgKpi(!flg_kpi)}
          />
          <Toggle
            vertical
            label={intl.formatMessage({
              id: "active",
            })}
            checked={active}
            onChange={() => setActive(!active)}
          />
        </div>
        <div className="mt-4 flex items-end justify-end">
          <Button submitting={loading} type="submit">
            <FormattedMessage id="add" />
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export default AddProductDialog;
